import { dataSelector } from '@nextiva/global-store';
import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { AttachmentType, getCampaignAttachment } from 'services';
import { FILE_ATTACHMENTS_KEY } from '../constants';

export function useGetFileAttachments(attachmentType: AttachmentType) {
  const globalStoreData = useSelector(dataSelector);
  const corpAcctNbr = globalStoreData.user?.profileDTO?.corpAcctNbr;
  const enabled = !!corpAcctNbr;

  const {
    data: fileAttachments,
    isLoading: isLoadingGetFileAttachments,
    refetch: refetchFileAttachments,
  } = useQuery([`${FILE_ATTACHMENTS_KEY}${attachmentType}`], {
    queryFn: () => getCampaignAttachment(corpAcctNbr, attachmentType),
    enabled,
  });
  return {
    fileAttachments,
    isLoadingGetFileAttachments,
    refetchFileAttachments,
  };
}
